import { useState } from 'react';
import { Outlet } from 'react-router';
import { Sidebar } from './Sidebar';
import { TimerBar } from './TimerBar';
import { SearchBar } from './SearchBar';
import { TimerProvider } from '@/contexts/TimerContext';
import { ToastProvider } from '@/contexts/ToastContext';
import { useNotificationPolling } from '@/hooks/useNotificationPolling';

// Component to activate notification polling
function NotificationPollingActivator() {
  useNotificationPolling();
  return null;
}

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <TimerProvider>
      <ToastProvider>
        <NotificationPollingActivator />
        <div className="flex h-screen overflow-hidden bg-gray-50 dark:bg-gray-900">
          {/* Mobile backdrop */}
          {sidebarOpen && (
            <div
              className="fixed inset-0 z-40 bg-gray-600/75 dark:bg-gray-900/80 md:hidden"
              onClick={() => setSidebarOpen(false)}
            />
          )}

          {/* Sidebar - always visible on desktop, overlay on mobile */}
          <div className={`fixed inset-y-0 left-0 z-50 md:relative md:flex ${sidebarOpen ? 'flex' : 'hidden md:flex'}`}>
            <Sidebar onClose={() => setSidebarOpen(false)} />
          </div>

          <div className="flex flex-1 flex-col overflow-hidden">
            {/* Mobile header with hamburger */}
            <div className="flex h-14 items-center border-b border-gray-200 bg-white px-4 dark:border-gray-700 dark:bg-gray-900 md:hidden">
              <button
                onClick={() => setSidebarOpen(true)}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                aria-label="Open menu"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg>
              </button>
              <h1 className="ml-4 text-lg font-bold text-brand-700 dark:text-brand-400">Jerico</h1>
            </div>
            <TimerBar />
            <main className="flex-1 overflow-y-auto bg-gray-50 dark:bg-gray-900">
              <Outlet />
            </main>
          </div>
          <SearchBar />
        </div>
      </ToastProvider>
    </TimerProvider>
  );
}
